/** @format */

import { useMemo } from 'react';
import { CellProps } from 'react-table';
import Text from '../Text';

type Renderer<T extends CellProps<any, any>> = (props: T) => JSX.Element;

const DateTimeTableCellFactory: Renderer<CellProps<any, any>> = function (Cell) {
  // const DateTimeTableCellFactory: IDateTimeTableCellFactory = function (Cell) {
  const dateTime = useMemo(() => new Date(Cell.value), [Cell.value]);

  return <span>{Cell.value ? <Text.Time dateTime={dateTime} /> : null}</span>;
};

export default DateTimeTableCellFactory;
